/** Dialog copy for the deactivate / reactivate flow (MKT-384). */
export const DEACTIVATE_DIALOG_COPY = {
  /** What happens to the user's license, stated before they confirm. */
  licenseFreed:
    'Their license will be freed and can be assigned to someone else.',
  licenseConsumed: 'This will use one of the account’s available licenses.',
  reportsWarning: 'The following direct reports will be unassigned:',
  blockedTitle: 'This user cannot be deactivated',
} as const;
